module.exports = __webpack_public_path__ + "static/palettte3-c24129c8490b5352be46df4ddba01c27.jpg";